export default __webpack_public_path__ + "static/media/grama-esportiva4.d5d74f35.jpg";